import { featuresData } from '@/mocks/homeData';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-3">平台优势</h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">为什么千万用户选择神马视频观看91视频、97视频、51视频高清影视</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {featuresData.map((feature) => (
            <div key={feature.id} className="group text-center p-6 md:p-7 rounded-2xl bg-background-100 border border-background-200/60 hover:border-primary-200/40 transition-all duration-300">
              <div className="w-14 h-14 md:w-16 md:h-16 mx-auto mb-4 rounded-2xl bg-primary-100 flex items-center justify-center group-hover:bg-primary-200 transition-colors">
                <i className={`${feature.icon} text-primary-600 text-2xl`}></i>
              </div>
              <h3 className="text-base md:text-lg font-semibold font-heading text-foreground-900 mb-2">{feature.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{feature.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}